import usePassiveRedux from '@sift/resift/usePassiveRedux';
import _get from 'lodash/get';
import * as Sift from '@sift/types';

function useClientOrgLevels(): string[] {
  const config = usePassiveRedux((state: any) =>
    _get(state, 'configurations.user', {}),
  ) as Sift.Configuration;

  const clientOrgLevelsFromAppState = _get(window, ['appState', 'clientOrgLevels']) as
    | string[]
    | undefined;

  if (clientOrgLevelsFromAppState) {
    return clientOrgLevelsFromAppState;
  }

  const clientOrgLevelsLayout = _get(config, 'layouts.org-levels', []);

  return clientOrgLevelsLayout.map((layoutItem: any) => layoutItem.name);
}

export default useClientOrgLevels;
